import { Total, TotalItem } from 'graphql-api/baskets-api-interfaces';

type TotalValueKey = keyof Omit<TotalItem, 'currency' | 'currencyRrp'>;

export const addConfirmedValuesForKey = (
  totals: Total,
  key: Uppercase<TotalValueKey>,
  alternativeKey?: Uppercase<TotalValueKey>,
) => {
  const property = key.toLowerCase() as Lowercase<TotalValueKey>;
  const alternativeProperty = alternativeKey?.toLowerCase() as
    | Lowercase<TotalValueKey>
    | undefined;

  if (
    totals.confirmed?.[alternativeProperty || property] !== undefined &&
    totals.requested[property] !==
      totals.confirmed?.[alternativeProperty || property]
  ) {
    return { actual: totals.confirmed?.[alternativeProperty || property] };
  }
  return undefined;
};
